export const ACTION_CODE = 'DEAL' + '_DAS' + '_ACTION';
